document.addEventListener('click', function (e) {
  if (e.target.closest('a.subnav__collection--link') 
    && e.target.closest('a.subnav__collection--link').href.indexOf('/collections/') > -1 
      || e.target.closest('a.gr-menu-item') 
      && e.target.closest('a.gr-menu-item').href.indexOf('/collections/') > -1) {
    const parts = e.target.closest('a').href.split('/collections/');
    const collectionHandle = parts[1].split('?')[0];
    const menuParams = e.target.closest('a').href.split('?')[1];
    const params = new URLSearchParams(window.location.search);
    const base = parts[0];
    
    // const hasFilterParams = [...params].filter(([key, value]) => {
    //   return key.includes('filter')
    // }).flat()
    
    // if (hasFilterParams.length === 0) {
    //   return
    // }

    e.preventDefault();
    
    fetch('/collections/' + collectionHandle + '?view=filters')
    .then(function (data) {
      return data.json();
    })
    .then(function (data) {
      let newUrlParams = new URLSearchParams();

      for (const [key, value] of params.entries()) {
        if (key.includes('filter')) {

          data.find(filter => {
            if (filter.name === key) {
              filter.values.find(v => {
                if (v.value === value) {
                  if (v.count > 0) {
                    newUrlParams.append(key, value);
                  }
                }
              })
            }
          });
        }
      }

      const design = data.find(filter => filter.design_metafield)
      if (design) {
        newUrlParams.append(design.design_param_name, design.design_metafield)
      }

      if (menuParams) {
        window.location.href = base + '/collections/' + collectionHandle + '?' + menuParams + '&' + newUrlParams.toString();
      } else {
        window.location.href = base + '/collections/' + collectionHandle + '?' + newUrlParams.toString();
      }
    })
  }
})